import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useOrganizationStore } from "@store/organizationStore";

import theme from "@theme/index";

const ChatUsageWarning = () => {
  const { organization } = useOrganizationStore();

  const spentTokens = organization?.chatUsageSpentTokens ?? 0;
  const availableTokens = organization?.chatUsageLimitTokens;

  if (!availableTokens) {
    return null;
  }

  const percentage = Math.round((spentTokens / availableTokens) * 100);

  let backgroundColor = "#43A047";

  let message = `Your team is at ${percentage}% of its free summary generation limit.`;

  if (percentage > 80) {
    backgroundColor = theme.palette.warning.main;
  }

  if (percentage >= 100) {
    backgroundColor = "#F4511E";
    message = "Your team is at 100% of its free summary generation limit.";
  }

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor,
        color: "white",
        display: "flex",
        height: "40px",
        justifyContent: "center",
      }}
    >
      <Typography variant="body2">
        <b>{message}</b> Reach out in the Chat to learn how you can unlock more.
      </Typography>
    </Box>
  );
};

export default ChatUsageWarning;
